import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

// Riceviamo refreshGlobalEvents da App.js
export const AdminDashboard = ({ token, onLogout, refreshGlobalEvents }) => {
  const [applications, setApplications] = useState([]);
  const [events, setEvents] = useState([]); // Serve per i nomi degli eventi
  const [loading, setLoading] = useState(true);

   // Funzione per caricare i dati internamente alla dashboard
  //useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [appsRes, eventsRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/applications`, {
            headers: { Authorization: `Bearer ${token}` }
          }),
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/events`)
        ]);
        setApplications(appsRes.data);
        setEvents(eventsRes.data);
      } catch (error) {
        console.error("Errore caricamento dati:", error);
        toast.error("Errore caricamento dati");
        if (error.response?.status === 401) onLogout();
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
      const fetchData = async () => {
    try {
      setLoading(true);
      const [appsRes, eventsRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/applications`, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/events`)
      ]);
       setApplications(appsRes.data);
        setEvents(eventsRes.data);
     } catch (error) {
       console.error("Errore caricamento dati:", error);
       toast.error("Errore caricamento dati");
       if (error.response?.status === 401) onLogout();
     } finally {
        setLoading(false);
      }
      };
      fetchData();
    }, [token, onLogout]);

  //  Funzione per cambiare lo stato (Confermato/Pending)
  const toggleStatus = async (appId, currentStatus) => {
    const newStatus = currentStatus === 'pending' ? 'confirmed' : 'pending';
    try {
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/applications/${appId}/status`,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // 1. Aggiorna la tabella admin locale
      setApplications(prev => prev.map(app => 
        app.id === appId ? { ...app, status: newStatus } : app
      ));
      // 2. Aggiorna lo stato GLOBALE (per il sito pubblico e i popup)
      if (refreshGlobalEvents) await refreshGlobalEvents();
      // 3. Ricarica gli eventi locali per aggiornare i nomi nella tabella
      const eventsRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/events`);
      setEvents(eventsRes.data);
      toast.success(`Stato aggiornato: ${newStatus === 'confirmed' ? 'Confermato' : 'In attesa'}`);
    } catch (error) {
      toast.error("Errore durante l'aggiornamento dello stato");
    }
  };

  // Funzione per scaricare il file CSV dell'evento
  const handleExport = async (eventId, eventTitle) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/events/${eventId}/export`,
        { 
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob' // Importante per gestire file binari/testo scaricabili
        }
      );
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `iscritti_${eventTitle.replace(/\s+/g, '_')}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Download CSV avviato");
    } catch (error) {
      toast.error("Errore durante l'esportazione dei dati");
    }
  };

  const handleDelete = async (appId) => {
    if (!window.confirm("Sei sicuro di voler eliminare questa iscrizione?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/applications/${appId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setApplications((prevApps) => prevApps.filter(a => a.id !== appId));
      // Anche l'eliminazione influisce sul conteggio ---
      // 3. MODIFICA: Chiama la funzione che aggiorna App.js
      if (refreshGlobalEvents) await refreshGlobalEvents();
      const eventsRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/events`);
      setEvents(eventsRes.data);
      toast.success("Iscrizione eliminata");
    } catch (error) {
      toast.error("Errore durante l'eliminazione");
    }
  };

  const getEventName = (eventId) => {
    const event = events.find(e => e.id === eventId);
    return event ? event.title : "Evento sconosciuto";
  };

  return (
    <div style={{ padding: "40px", color: "white", maxWidth: "1200px", margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }}>
        <h1>Pannello Comando - Iscrizioni</h1>
        <button 
          onClick={onLogout} 
          style={{ padding: "10px 20px", background: "#ef4444", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}
        >
          Logout
        </button>
      </div>

      {loading ? (
        <p>Caricamento dati tattici...</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", background: "#18181B", borderRadius: "8px" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #27272A", color: "#A1A1AA" }}>
                <th style={{ padding: "15px", textAlign: "left" }}>Evento</th>
                <th style={{ padding: "15px", textAlign: "left" }}>Team</th>
                <th style={{ padding: "15px", textAlign: "center" }}>Op.</th>
                <th style={{ padding: "15px", textAlign: "left" }}>Stato</th> {/* AGGIUNTA COLONNA */}
                <th style={{ padding: "15px", textAlign: "left" }}>Contatti</th>
                <th style={{ padding: "15px", textAlign: "center" }}>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app) => (
                <tr key={app.id} style={{ borderBottom: "1px solid #27272A" }}>
                  <td style={{ padding: "15px", color: "#3b82f6", fontWeight: "600" }}>
                    {getEventName(app.event_id)}
                    {/* AGGIUNTA: Pulsante export rapido accanto al nome evento */}
                    <button 
                      onClick={() => handleExport(app.event_id, getEventName(app.event_id))}
                      style={{ display: "block", fontSize: "10px", marginTop: "5px", background: "#27272A", color: "#10b981", border: "none", padding: "2px 5px", cursor: "pointer", borderRadius: "3px" }}
                    >
                      Scarica CSV
                    </button>
                  </td>
                  <td style={{ padding: "15px", fontWeight: "bold" }}>{app.team_name}</td>
                  <td style={{ padding: "15px", textAlign: "center" }}>{app.operators_count}</td>
                  
                  {/* AGGIUNTA: Gestione Stato con Checkbox */}
                  <td style={{ padding: "15px" }}>
                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer", gap: "8px" }}>
                      <input 
                        type="checkbox"
                        checked={app.status === 'confirmed'}
                        onChange={() => toggleStatus(app.id, app.status)}
                        style={{ cursor: "pointer" }}
                      />
                      <span style={{ color: app.status === 'confirmed' ? "#10b981" : "#f59e0b", fontSize: "0.9em" }}>
                        {app.status === 'confirmed' ? "Confermato" : "In attesa"}
                      </span>
                    </label>
                  </td>

                  <td style={{ padding: "15px", fontSize: "0.85em" }}>
                    {app.contact_email} <br/> <span style={{color: "#71717A"}}>{app.contact_phone}</span>
                  </td>
                  <td style={{ padding: "15px", textAlign: "center" }}>
                    <button 
                      onClick={() => handleDelete(app.id)}
                      style={{ padding: "5px 10px", background: "none", border: "1px solid #ef4444", color: "#ef4444", borderRadius: "4px", cursor: "pointer" }}
                    >
                      Elimina
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {applications.length === 0 && <p style={{textAlign: "center", padding: "40px"}}>Nessun operatore iscritto.</p>}
        </div>
      )}
    </div>
  );
};